import { use, useCallback } from 'react';
import { useRefBox } from '@frameio/vapor-migration/hooks/useRefBox';
import { UpdateAppParams } from '../../routing/params/params';

export type QuickshareHook = { isEnabled(): boolean } & ((
  shareId: string | null
) => boolean);

export function useQuickshare(): QuickshareHook {
  const [, replaceState] = use(UpdateAppParams);
  const box = useRefBox({ replaceState });
  const isEnabled = useCallback(() => true, []);
  const quickshare = useCallback(
    (shareId: string | null) => {
      box.current.replaceState({ share: shareId });
      return true;
    },
    [box]
  );
  Object.assign(quickshare, { isEnabled });
  return quickshare as QuickshareHook;
}
